import {Component, Input, ViewEncapsulation} from '@angular/core';
import {UserDto} from '../../../../Models/User/user.interface';

@Component({
  selector: 'app-multisession-user',
  templateUrl: './multisession-user.component.html',
  styleUrls: ['./multisession-user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class MultisessionUserComponent {
  @Input() user!: UserDto;
}
